// What a partner SELLS — the third and last of the three partner-shaped lists,
// and the one that was missing. Keeping them straight matters, because two of
// them look interchangeable and are not:
//
//   enabled_components  WIDGETS. Which custom elements the loader injects on
//                       the partner's page: search / cart / checkout /
//                       payment. Purely a rendering fact — it says nothing
//                       about what may be transacted, and the server has never
//                       read it.
//
//   enabled_products    PRODUCTS (this file). What ops actually sold the
//                       partner: rentals, transfers. A partner-row fact, so it
//                       survives credential rotation, and it gates the /v1 API
//                       — not just what renders.
//
//   scopes              What a CREDENTIAL asked for. Chosen per credential and
//                       re-chosen on every rotation, so it is the weakest of
//                       the three as a statement of the commercial deal. A
//                       credential can perfectly well hold `transfers:book`
//                       for a partner who was never sold transfers — which is
//                       why BOTH checks run: the scope says this key is
//                       allowed to try, the product says the partner is
//                       entitled at all.
//
// The failure this vocabulary exists to prevent is someone reaching for
// enabled_components to answer "can they book transfers?". A widget name must
// never pass as a product name; `isPartnerProduct` is the guard that says so.

export const PARTNER_PRODUCTS = ['rentals', 'transfers'] as const;

export type PartnerProduct = (typeof PARTNER_PRODUCTS)[number];

export function isPartnerProduct(s: string): s is PartnerProduct {
  return (PARTNER_PRODUCTS as readonly string[]).includes(s);
}
